import { FC } from 'react';
import Edit from 'components/elements/components/Edit';

const Screen: FC = () => {
  return (
    <Edit
      elementsEntityName="element"
      elementsEndpoint="elements"
    />
  );
};

export default Screen;
